export const config = {
  halftimeDuration: 10 * 60,
} as const;
